let storeRef = null;
const setStoreRef = (store) => {
	storeRef = store;
	return store;
};
const getStoreRef = () => storeRef;
export { getStoreRef, setStoreRef };
